module.exports = __webpack_public_path__ + "img/logo3.92eaa796.png";